import {
  useFacetContext,
  useRouterContext,
} from '../../../../context/PlpContext';
import { useAnalyticsData } from '../../../../hooks/useAnalyticsData';

export const useClearFiltersData = () => {
  const facetContext = useFacetContext();
  const router = useRouterContext();
  const analyticsData = useAnalyticsData();

  return {
    facetContext,
    analyticsData,
    router,
  };
};
